import profile01 from "../assets/styles/profile/profile01.webp"
import profile02 from "../assets/styles/profile/profile02.webp"
import profile03 from "../assets/styles/profile/profile03.webp"
import profile04 from "../assets/styles/profile/profile04.webp"
import profile05 from "../assets/styles/profile/profile05.webp"
import profile06 from "../assets/styles/profile/profile06.webp"

import background01 from "../assets/styles/background/background01.webp"
import background02 from "../assets/styles/background/background02.webp"
import background03 from "../assets/styles/background/background03.webp"
import background04 from "../assets/styles/background/background04.webp"
import background05 from "../assets/styles/background/background05.webp"
import background06 from "../assets/styles/background/background06.webp"

export const styleData = [
    {
        profile: profile01,
        background: background01
    },
    {
        profile: profile02,
        background: background02
    },
    {
        profile: profile03,
        background: background03
    },
    {
        profile: profile04,
        background: background04
    },
    {
        profile: profile05,
        background: background05
    },
    {
        profile: profile06,
        background: background06
    }
]